export default __webpack_public_path__ + "static/media/about10.bfdc4d77.jpeg";